import { globalFetch } from './globalActions';
import { PROG_RESUME_HAS_ERRORED, PROG_RESUME_IS_LOADING, PROG_RESUME_FETCH_DATA_SUCCESS } from './types';
import { getDeviceID, getTokenID, getItemName } from '../mys4c_helpers';

///////////
// Programme Resume Section //
///////////

export function fetchProgResume(mode, pid) {
	const tokenId = getTokenID();
	const itemName = getItemName(pid, tokenId);
	const advertisingId = getDeviceID();

	if(tokenId) {
		return globalFetch({
				urlPath: `resumev2`,
				urlSrc: 3,
				extraParams: `?mode=${mode}&pid=${pid}&tokenId=${tokenId}&advertisingId=${advertisingId}&itemName=${itemName}`,
				reducerIsLoading: PROG_RESUME_IS_LOADING,
				reducerError: PROG_RESUME_HAS_ERRORED,
				dispatchSuccess: (itemObj, dispatch) => {
					itemObj.pid = pid;
					dispatch({ type: PROG_RESUME_FETCH_DATA_SUCCESS, items: itemObj });
				}
		});
	} else {
		return {
			type: PROG_RESUME_FETCH_DATA_SUCCESS,
			items: {pid}
		};
	}
}

export function resetProgResume() {
	return {
		type: PROG_RESUME_FETCH_DATA_SUCCESS,
		items: null
	};
}
